import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { environment } from 'src/environments/environment';
import { applnInfo } from '../Models/ApplnInfo';
import { MasterService } from '../services/master-mom.service';
import { ToastrUtilsService } from '../services/toastr-utils.service';
import { UserService } from '../services/user.service';
import { UtilityService } from '../services/utility.service';
import { RSAHelper } from '../services/RSAHelper';
@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    providers: [ToastrUtilsService]
})

export class HeaderComponent implements OnInit {
    public filled = false; allapps: any = [];
    public firstname: string = "";

    @ViewChild('closeBtn') closeBtn: ElementRef;
    @ViewChild('closeBtnApps') closeBtnApps: ElementRef;

    constructor(public router: Router, private utilservice: UtilityService,
        public RSAHelper: RSAHelper, private spinner: NgxSpinnerService, private toaster: ToastrUtilsService, private userService: UserService, private masterservice: MasterService) { this.spinner.show();}
    title = 'ngx-skeleton-loader-demo';
    animation = 'pulse';
    contentLoaded = false;
    user: any = []; useremail: string = "";
    intervalId; keyword = "applnname";
    submitcnt: number = 0;
    public SubmenuShow1 = true;
    public SubmenuShow2 = false;
    public SubmenuShow3 = false;
    public SubmenuShow4 = false;
    public SubmenuShow5 = false;
    public SubmenuShowAdmin = false;
    objapplnInfo: applnInfo = new applnInfo();
    sectionname: string = ""; sectionid: string = "";
    savesection: boolean = false; limit = 10; page = 1;
    txtFilter = ''; p = 1; userSectionlist: any = []; applnList: any = []; userprofileInfo: any = [];
    sectionformvalue: string = "";

    ngOnInit(): void {
        
        const menuicon = document.getElementsByClassName('gn-icon-menu')[0];
        menuicon.addEventListener('mouseover', IconmouseOver);
        menuicon.addEventListener('click', mouseOver);

        function IconmouseOver() {
            menuwrapper.classList.add('gn-open-part');
        }

        const menuwrapper = document.getElementsByClassName('gn-menu-wrapper')[0];
        menuwrapper.addEventListener('mouseover', mouseOver);
        menuwrapper.addEventListener('mouseout', mouseOut);

        // menuwrapper.classList.add('gn-open-all');
        function mouseOver() {
            menuwrapper.classList.add('gn-open-all');
        }
        function mouseOut() {
            menuwrapper.classList.remove('gn-open-all');
            menuwrapper.classList.remove('gn-open-part');
            // menuwrapper.classList.add('gn-open-part');
        }
        // fixed header
        window.onscroll = function () { myFunction(); };

        // Get the header
        const header = document.getElementById('myHeader');

        // Get the offset position of the navbar


        // Add the sticky class to the header when you reach its scroll position. Remove 'sticky' when you leave the scroll position
        function myFunction() {

            if (window.pageYOffset >= header.offsetTop) {
                header.classList.add('sticky');
            }
            if (window.pageYOffset <= 90) {
                header.classList.remove('sticky');

            }
        }

        

        const user = this.userService.getUserInfo();
        if (!environment.production) {
            this.useremail = environment.testEmail;
            this.RefreshSecurityToken(this.useremail);

            // this.LoadMenu(this.useremail);
            // this.LoadApplication(this.useremail);
        }
        else {
            console.log('header');
            this.useremail = user.email;
            this.firstname = user.sub;
            this.RefreshSecurityToken(this.useremail);

           // this.LoadApplication(this.useremail);
        }
    }
    ngAfterViewInit(): void {
        this.spinner.hide();
    }
    onSubmit(form: NgForm, formname: string) {
        debugger;
        try {
            if ((formname == "addapplicationform") && (form.valid)) {
                this.submitcnt = this.submitcnt + 1;
                //if(this.submitcnt==1){
                this.addApplication();
                //}
                console.log(this.submitcnt);
            }
            else if ((formname == "addsectionform")) {
                this.submitcnt = this.submitcnt + 1;
                this.sectionformvalue = form.value.sectionname;
                if (form.valid) this.AddNewSection();
                console.log(this.submitcnt);
            }
        }
        catch (err) { console.log(err); }
    }

    addApplication() {
        try {
            this.spinner.show();

            this.userprofileInfo = this.userService.getUserProfileInfo(this.user.email);
            /*if(this.userprofileInfo!=null)
            {
                this.userprofileInfo=JSON.parse(this.userprofileInfo);
            }*/
            const objtrxndata = {
                "applnname": this.objapplnInfo.applnname,
                "applnurl": this.objapplnInfo.applnurl,
                "applnlogo": this.objapplnInfo.applnlogo,
                "PRNumber": this.userprofileInfo.userPRnumber,
                "appid": 0,
                "email": this.user.email,
            }
            this.masterservice.addAppln(objtrxndata)
                .subscribe((result: any) => {
                    const response = result.data;
                    if (response.dictionary.IntResult > 0) {
                        this.toaster.SuccessCustomMessage('Application added successfully.');
                        this.closeBtnApps.nativeElement.click();
                        this.router.navigate(['home']);
                        this.LoadApplication(this.useremail);
                    } else {
                        if (response.dictionary.StringResult.includes('ORA-00001: unique constraint')) {
                            this.toaster.ErrorCustomMessage('Application Already exists');
                        } else {
                            this.toaster.ErrorCustomMessage('There was an unexpected error.');
                        }
                    }
                },
                    (error) => {
                        this.toaster.ErrorCustomMessage('There was an unexpected error.');
                        this.spinner.hide();
                    }
                ).add(() => {
                    this.spinner.hide();
                    //this.closeBtn.nativeElement.click();
                });
        }
        catch (err) {
            this.toaster.ErrorCustomMessage('There was an unexpected error.');
            this.spinner.hide();
        }
    }

    openhome() {
        this.router.navigateByUrl("/home").then(() => {
            window.location.reload()
        });
    }

    getuserdetails() {
        try {
            var emailid: string = "";
            if ((environment.production != true) && (this.user == null)) {
                emailid = environment.testEmail;
            }
            else {
                this.user = this.userService.getUserInfo();
                if (this.user != null) {
                    emailid = this.user.email;
                }
            }
            return emailid;
        }
        catch (err) { console.log(err); }
    }


    AddNewSection() {
        try {
          
            this.spinner.show();
            this.useremail = this.getuserdetails();
            /*if((this.userprofileInfo==null)||(this.userprofileInfo==""))
            {this.userprofileInfo=this.userService.getUserProfileInfo(this.useremail);}
            */
            /*if(this.userprofileInfo!="")
            {
                this.userprofileInfo=JSON.parse(this.userprofileInfo);
            }*/
            const selectedApps = this.applnList.filter(item => item.checked === true);
            if (selectedApps.length == 0) {
                this.toaster.showWarningToaster('Please select apps');
                return;
            }
            if (this.sectionname.trim() == "") {
                this.toaster.showWarningToaster("Please enter section name");
                return;
            }
            //console.log(selectedApps);
            var appID = '';
            for (var apps of selectedApps) {
                appID = appID + "," + apps.appid;
            }
            if (appID.substring(0, 1) == ",") appID = appID.slice(1);
            console.log(appID);

            this.userService.getUserProfileInfo(this.useremail).
                subscribe((result: any) => {
                    var response;
                    if (result.data == undefined) {
                        response = result;
                        this.userprofileInfo = response;
                    }
                    else { response = result.data; this.userprofileInfo = JSON.parse(this.userService.loadprofiledata(response)); }

                    if (response != null) {
                        const objTxnData = {
                            "sectionname": this.RSAHelper.encryptWithPublicKey(JSON.stringify(this.sectionname)),
                            "employeeuno": this.RSAHelper.encryptWithPublicKey(JSON.stringify(this.userprofileInfo.employeeuno)),
                            "appid": this.RSAHelper.encryptWithPublicKey(JSON.stringify(appID)),
                            "PRNumber": this.RSAHelper.encryptWithPublicKey(JSON.stringify(this.userprofileInfo.userPRnumber)),
                            "email": this.RSAHelper.encryptWithPublicKey(JSON.stringify(this.useremail))
                        }

                        this.masterservice.AddNewSection(JSON.stringify(objTxnData))
                            .subscribe((result: any) => {
                                const response = result.data;
                                if (response.dictionary.IntResult > 0) {
                                    this.toaster.SuccessCustomMessage('Section added successfully.');
                                    this.closeBtn.nativeElement.click();
                                    //redirect to myApps page                        
                                    this.LoadApplication(this.useremail);
                                    this.LoadMenu(this.useremail);
                                    this.utilservice.updatesidebar("section added successfully");
                                    //this.router.navigate(['home']);
                                    //window.location.reload();
                                } else {
                                    if (response.dictionary.StringResult.includes('ORA-00001: unique constraint')) {
                                        this.toaster.ErrorCustomMessage('Section Already exists');
                                    } else {
                                        this.toaster.ErrorCustomMessage('There was an unexpected error.');
                                    }
                                }
                            },
                                (error) => {
                                    this.toaster.ErrorCustomMessage('There was an unexpected error.');
                                    this.spinner.hide();
                                }
                            ).add(() => {
                                this.spinner.hide();
                            });
                    }
                });
        }
        catch (err) {
            this.toaster.ErrorCustomMessage('There was an unexpected error.');
            this.spinner.hide();
        }
    }


    LoadMenu(userEmail: string) {
        try { 
            const objTxnData = {
                "email": this.RSAHelper.encryptWithPublicKey(JSON.stringify(userEmail))
            };
            console.log('From Header');
            this.masterservice.allUserSections(JSON.stringify(objTxnData)).subscribe((result: any) => {
                this.userSectionlist = result.data;
                this.contentLoaded = true;
                console.log("sectionlist" + this.userSectionlist);
                setTimeout(() => { this.spinner.hide(); }, 1000);
            },
                (error) => {
                    console.log(error);
                    this.contentLoaded = false;
                   // this.toaster.ErrorCustomMessage('Unable to load Menu.');
                    this.spinner.hide();
                }
            ).add(() => {
                // Called when operation is complete (both success and error)          
                this.spinner.hide();
            });
        } catch (err) { console.log(err); }
    }


    RefreshSecurityToken(userEmail) {
        try {

            const objTxnData = {
                "email": userEmail,
                "isExternal": environment.isExternal
            };
            let encryptedioparam = this.RSAHelper.encryptWithPublicKey(JSON.stringify(objTxnData));
            this.masterservice.refreshToken(JSON.stringify(encryptedioparam)).subscribe((result: any) => {
                console.log(result);
                sessionStorage.removeItem('iammwtoken');
                sessionStorage.setItem('iammwtoken', result.token);

                 this.LoadMenu(this.useremail);
                 this.LoadApplication(this.useremail);
                

            },
                (error) => {
                    sessionStorage.removeItem('iammwtoken');
                    this.spinner.hide();
                }
            ).add(() => {
                this.spinner.hide();
            });
        }
        catch (err) { console.log(err); }
    }


    loaduser() {
        //this.user = this.userService.getUserProfileInfo();
        /*if(this.user!=null)
        {
          this.useremail=JSON.parse(this.user).firstname;
        }*/

    }
    clearapplndata() {
        try {
            this.objapplnInfo.applnlogo = ""; this.objapplnInfo.applnname = "";
            this.objapplnInfo.applnurl = "";
        }
        catch (err) {
            console.log(err);
        }
    }

    LogOut() {
        try { 
            console.log('idle time out');

            this.userService.logout();
            sessionStorage.removeItem('iammwtoken');
           // window.location.href = environment.issuer_uri + '/idp/startSLO.ping?TargetResource=https%3A%2F%2Foneid.dewa.gov.ae';
  
            setTimeout(function(){ 
              console.log('idle time out step 2');
              window.location.href = environment.issuer_uri + '/idp/startSLO.ping?TargetResource=https%3A%2F%2Foneid.dewa.gov.ae';

              setTimeout(function(){ 
                console.log('idle time out step 3');
                window.location.href = environment.issuer_uri + '/idp/startSLO.ping?TargetResource=https%3A%2F%2Foneid.dewa.gov.ae';
               }, 500);

             }, 500);

          }
          catch (err) {
            console.log(err);
            setTimeout(function(){ 
              console.log('idle time out step 4');
              window.location.href = environment.issuer_uri + '/idp/startSLO.ping?TargetResource=https%3A%2F%2Foneid.dewa.gov.ae';
             }, 500);
          }
    }



    selectEvent(item) {
        //window.open()
        //console.log(item);
        window.open(item.applnurl);
    }

    onChangeSearch(val: string) {
        // fetch remote data from here
        // And reassign the 'data' which is binded to 'data' property.
    }

    onFocused(e) {
        // do something when input is focused      
    }

    LoadApplication(useremail: string) {
        try {

            const objTxnData = {
                "email": this.RSAHelper.encryptWithPublicKey(JSON.stringify(useremail)),
                "isExternal": this.RSAHelper.encryptWithPublicKey(JSON.stringify(environment.isExternal)),
            };

            this.masterservice.allApplns(JSON.stringify(objTxnData)).subscribe((result: any) => {
                var resultdata = result.data;
                for (let i = 0; i < resultdata.length; i++) {
                    let appid = resultdata[i].appid;
                    //if (this.popupdata1.filter(item => item.appid === appid) == 0)
                    for (let j = 0; j < resultdata[i].applicationInfo.length; j++) {
                        this.allapps.push(resultdata[i].applicationInfo[j]);
                    }
                }
            },
                (error) => {
                   // this.toaster.ErrorCustomMessage('There was an unexpected error.');
                }
            ).add(() => {
            });
        }
        catch (err) { console.log(err); }
    }
}